import { View, Text, Link } from '@react-pdf/renderer';
import { getTokenHex } from '@util/helpers';

export default function PDFBrandingFooter() {
  return (
    <View
      fixed
      style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 12,
        width: '100%',
        marginTop: 10,
        paddingHorizontal: 80,
        paddingVertical: 24,
        backgroundColor: getTokenHex(['surface', 'containerLow']),
        color: getTokenHex(['surface', 'onSurfaceVariant'])
      }}
      wrap={false}
    >
      <View
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          width: '581px',
          fontSize: '11px'
        }}
        render={({ pageNumber, totalPages }) =>
          pageNumber === totalPages && (
            <>
              <Text style={{ color: 'black', fontWeight: 'semibold' }}>
                Fora: Connected Intelligence at Work.&nbsp;
              </Text>
              <Text>This meeting summary gives a glimpse of what’s possible with FORA —</Text>
              <Text>
                insights tailored to your goals and a suite of capabilities built for
                forward-thinking leaders.&nbsp;
              </Text>
              <Link
                src='https://fora.day/'
                style={{
                  fontWeight: 'semibold',
                  color: getTokenHex(['brandPrimary', 'primary']),
                  textDecoration: 'none'
                }}
              >
                <Text>Learn More →</Text>
              </Link>
            </>
          )
        }
      />
      <Text
        render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`}
        style={{ fontSize: '11px' }}
      />
    </View>
  );
}
